import React, { useState, useEffect } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { MuiOtpInput } from 'mui-one-time-password-input'

import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"
import queryString from "query-string"

const ValidateCode = () => {
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState()

  const [resendCode, setResendCode] = useState(false)
  // Point 14 : renvoi de l'email « creer votre mot de passe » depuis l'ecran final
  const [resendEmail, setResendEmail] = useState(false)

  const [isValidRequest, setIsValidRequest] = useState(null)
  const [infos, setInfos] = useState({})
  useEffect(() => {
    const urlParams = queryString.parse(location.search)
    window.history.replaceState(null, null, window.location.pathname)
    if (urlParams.i && urlParams.email) {
      if (urlParams?.noValid === "dbff0d04-628a-47ce-960e-4a216b3ff3f0") {
        //on vient direct de la page signup
        setInfos({
          id : urlParams.i,
          email : urlParams.email
        })
        setIsValidRequest(true)
      } else {
        //on va vérifier que les infos sont correctes
        APIS.checkRegisterRecruiter({email : urlParams.email, id : urlParams.i}).then((result) => {
          if (result?.message === "checkRegisterRecruiter") {
            setInfos({
              id : urlParams.i,
              email : urlParams.email
            })
            setIsValidRequest(true)
          } else {
            setIsValidRequest(false)
          }
        })
      }
    } else {
      setIsValidRequest(false)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Validation | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          {isValidRequest === "final" &&
            <Box sx={{ mb: 3, textAlign:"center" }}>
              {/* Points 13 + 14 : un titre qui dit ce qui se passe, et pas de
                  bouton « Se connecter » vers une impasse — le recruteur n'a
                  pas encore de mot de passe, il doit passer par sa boite mail. */}
              <Typography
                color="textBlack"
                variant="h2"
              >
                Choisissez votre mot de passe
              </Typography>
              <Typography
                color="textPrimary"
                gutterBottom
                mt={2}
                variant="body2"
              >
                Ouvrez l'email que nous venons de vous envoyer pour choisir votre mot de passe.
              </Typography>
              <Box sx={{
                py: 2,
                fontSize:"16px",
                textAlign:"center",
                color : "text.black",
                userSelect:"none"
              }}>
                {resendEmail === false ? (
                  <Link
                    sx={{cursor:"pointer"}}
                    onClick={() => {
                      APIS.askForNewPasswordEmail({email : infos?.email}).then((result) => {
                        if (result?.message === "askForNewPasswordEmail") {
                          setResendEmail(true)
                        }
                      })
                    }}
                  >
                    Renvoyer l'email
                  </Link>
                ) : (
                  <b>Email envoyé&nbsp;!</b>
                )}
              </Box>
            </Box>
          }
          {isValidRequest === false &&
            <Box sx={{ mb: 3, textAlign:"center" }}>
              <Typography
                color="textBlack"
                variant="h2"
              >
                Lien invalide
              </Typography>
              <Typography
                color="textPrimary"
                gutterBottom
                variant="body2"
              >
                Les informations ne sont pas valides
              </Typography>
            </Box>
          }
          {isValidRequest === true &&
            <Formik
              initialValues={{
                otp : '',
              }}
              // Point 2 : aucune validation pendant la saisie. L'erreur ne
              // s'affiche qu'au clic sur « Suivant », et disparait des que
              // l'utilisateur corrige le champ (voir onChange plus bas).
              validateOnChange={false}
              validateOnBlur={false}
              validationSchema={Yup.object().shape({
                otp: Yup.string()
                  .length(6, 'Saisissez les 6 chiffres du code.')
                  .required('Saisissez les 6 chiffres du code.'),
              })}
              onSubmit={(values, { setSubmitting }) => {
                setAlertMessage("");
                const vals = { id : infos?.id, email: infos?.email, otp: values.otp }
                APIS.validCodeRecruiter(vals).then(result => {
                  if (result?.message === "validCodeRecruiter") {
                    APIS.askForNewPasswordEmail({email : infos?.email}).then(resultPassword => {
                      if (resultPassword?.message === "askForNewPasswordEmail") {
                        setIsValidRequest("final")
                      }
                    })
                  } else {
                    setAlertMessage("Ce code est incorrect ou a expiré. Demandez-en un nouveau.");
                    setSubmitting(false);
                  }
                })

              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                setFieldValue,
                setFieldError,
                handleSubmit,
                isSubmitting,
                submitCount,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box sx={{ mb: 3, textAlign:"center" }}>
                    <Typography
                      color="textBlack"
                      variant="h2"
                    >
                      Vérifiez votre adresse email
                    </Typography>
                    <Typography
                      color="textPrimary"
                      gutterBottom
                      variant="body2"
                    >
                      Nous avons envoyé un e-mail de confirmation à {infos?.email}
                    </Typography>
                  </Box>
                  {/* Point 2 : pas d'auto-submit a la 6e case — la soumission
                      partait avant que la valeur ne soit dans le state et
                      declenchait « Le code est requis » sur un code complet. */}
                  <MuiOtpInput
                    length={6}
                    TextFieldsProps={{
                      placeholder: '-'
                    }}
                    value={values.otp}
                    onChange={(val) => {
                      setFieldValue("otp", val, false)
                      // l'utilisateur corrige : les messages disparaissent
                      if (errors.otp) { setFieldError("otp", undefined) }
                      if (alertMessage) { setAlertMessage("") }
                    }}
                  />
                  {submitCount > 0 && errors.otp && (
                    <Typography variant="body2" color="error" sx={{ mt: 2, textAlign:"center" }}>
                      {errors.otp}
                    </Typography>
                  )}
                  <Box sx={{ py: 2 }}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      endIcon={<ChevronRightIcon/>}
                    >
                      Suivant
                    </Button>
                  </Box>
                  <Box sx={{
                    fontSize:"16px",
                    textAlign:"center",
                    color : "text.black",
                    userSelect:"none"
                  }}>
                    {resendCode === false &&
                      <Link
                        sx={{cursor:"pointer"}}
                        onClick={() => {
                          APIS.resendCodeRecruiter({ id : infos?.id, email: infos?.email}).then((result) => {
                            if (result?.message === "resendCodeRecruiter") {
                              setResendCode(true)
                            } else {
                              alert("Erreur\u00a0!")
                            }
                          })
                        }}
                      >
                        Renvoyer le code
                      </Link>
                    }
                    {resendCode === true &&
                      <b>Email envoyé&nbsp;!</b>
                    }
                  </Box>
                  {alertMessage && alertMessage.length > 0 && (
                    <Box
                      sx={{
                        pb: 1,
                        pt: 2
                      }}
                    >
                      <Typography
                        align="center"
                        color="red"
                        variant="body1"
                      >
                        {alertMessage}
                      </Typography>
                    </Box>
                  )}
                </form>
              )}
            </Formik>
          }
        </Container>
      </Box>
    </>
  );
};

export default ValidateCode;
